import { Dispatch } from '@reduxjs/toolkit';
import axios from 'axios';

import { sendRequest, receiveResponse } from 'main/store/common/reducer';
import { GamesResults } from 'main/store/games/state';
import { Player } from 'main/store/players/state';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/sagami-bombers/asia-northeast1/api';

export const callRestAPI = async <T>(dispatch: Dispatch, execFunc: () => Promise<T>, successCallback?: (response: T) => void, failCallback?: () => void) => {
    try {
        dispatch(sendRequest());
        const response = await execFunc();
        if (successCallback) {
            successCallback(response);
        }
    } catch (err) {
        console.log(err);
        if (failCallback) {
            failCallback();
        } else {
            throw err;
        }
    } finally {
        dispatch(receiveResponse());
    }
}

export const createHeaders = (token: string) => ({
    headers: { Authorization: `Bearer ${token}` }
})

export const signIn = async (token: string) => {
    await axios.post(`${API_URL}/sign-in`, {}, createHeaders(token));
}

export const getGamesResults = async (): Promise<GamesResults> => {
    return {
        2021: {
            regular: {
                summary: {
                    official: { win: 0, lose: 1, draw: 0 },
                    practice: { win: 1, lose: 14, draw: 0 },
                },
                scores: [
                    { id: 1, date: '09/11', event: '練習試合', opponent: '中和田クレインズ', score: '2 - 10' },
                    { id: 2, date: '09/04', event: '練習試合', opponent: '上九沢白鳥野球部', score: '4 - 12' },
                    { id: 3, date: '08/22', event: '練習試合', opponent: '有鹿バッファローズ', score: '0 - 22' },
                    { id: 4, date: '08/22', event: '練習試合', opponent: '県央少年野球部', score: '4 - 19' },
                    { id: 5, date: '08/21', event: '練習試合', opponent: '水郷田名ミラクルズ', score: '4 - 6' },
                    { id: 6, date: '07/31', event: '練習試合', opponent: '矢部四少年野球部', score: '8 - 11' },
                    { id: 7, date: '07/25', event: '練習試合', opponent: 'すすきの子ども会野球部', score: '0 - 26' },
                    { id: 8, date: '07/24', event: '練習試合', opponent: '大沼レッズ', score: '2 - 23' },
                    { id: 9, date: '07/18', event: '練習試合', opponent: '旭町少年野球部', score: '6 - 3' },
                    { id: 10, date: '07/17', event: '練習試合', opponent: '旭', score: '0 - 22' },
                ]
            },
            junior: {
                summary: {
                    official: { win: 0, lose: 1, draw: 0 },
                    practice: { win: 0, lose: 6, draw: 0 },
                },
                scores: [

                ]
            },
            // superJunior: {
            //     summary: {
            //         official: { win: 0, lose: 0, draw: 0 },
            //         practice: { win: 0, lose: 0, draw: 0 },
            //     },
            //     games: [

            //     ]
            // }
        },
        2020: {
            regular: {
                summary: {
                    official: { win: 0, lose: 0, draw: 0 },
                    practice: { win: 0, lose: 0, draw: 0 },
                },
                scores: []
            },
            junior: {
                summary: {
                    official: { win: 0, lose: 0, draw: 0 },
                    practice: { win: 0, lose: 0, draw: 0 },
                },
                scores: []
            }
        }
    } as GamesResults;
}


export const getGraduactionPlayers = async (): Promise<{ [year: number]: Player[] }> => {
    return {
        2020: [
            { role: '主将', position: '', name: '井上　斗翔' },
            { role: '副将', position: '', name: '雨沼　慶太' },
            { role: '副将', position: '', name: '小田　空' },
            { role: '', position: '', name: '大河内　遥希' },
            { role: '', position: '', name: '川島　颯太' },
            { role: '', position: '', name: '齋藤　汐音' },
            { role: '', position: '', name: '大本　晴己' },
            { role: '', position: '', name: '大島　優翔' },
        ],
        2019: [
            { role: '主将', position: '', name: 'シュミドル　ウィリアム' }
        ],
        2018: [
            { role: '主将', position: '', name: '小林　瑠太' },
            { role: '副将', position: '', name: '萩原　慶汰' },
            { role: '副将', position: '', name: '押見　佳奈' },
            { role: '', position: '', name: '中沢　彩乃' },
            { role: '', position: '', name: '富岡　煌陽' },
            { role: '', position: '', name: '松尾　佳恵' },
            { role: '', position: '', name: '諏訪　陽大' },
            { role: '', position: '', name: '梶田　颯' },
            { role: '', position: '', name: 'シュミドル　ケイレブ' },
            { role: '', position: '', name: '松尾　和伸' },
            { role: '', position: '', name: 'デイビス　宏輝' },
            { role: '', position: '', name: '立花　百華' }
        ]
    }
}

export * from './contacts';
export * from './members';
export * from './videos';
